<template>
  <v-flex>
    <div v-if="submit_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>

      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
                id="update_announcement"
                @submit.prevent="validateBeforeSubmit('updateAnnouncement')"
                data-vv-scope="updateAnnouncement"
                ref="announcement_form"
                v-model="valid"
            >
              <v-card-text>
                <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                  <v-layout row wrap>
                    <v-flex xs12 md8 lg4>
                      <label>Service Alert Type</label>
                      <v-autocomplete
                          :items="announcement_types"
                          name="Service Alert Type"
                          label="Select Service Alert Type"
                          v-model="announcement_detail.type_object.id"
                          item-text="title"
                          item-value="id"
                          v-validate="'required'"
                          solo flat
                          selected
                          disabled
                      >
                        <!--                          :error-messages="errors.collect('updateAnnouncement.Announcement Type')"-->
                        <!--                          @change="changeType(announcement_detail.type_object.id)"-->
                      </v-autocomplete>
                    </v-flex>


                    <v-flex xs12 md8 lg4>
                      <label>City Name</label>
                      <v-autocomplete
                          :items="cityList"
                          name="CityName"
                          label="Select City"
                          v-model="announcement_detail.city_id"
                          item-text="name"
                          item-value="id"
                          v-validate="'required'"
                          :error-messages="errors.collect('updateAnnouncement.CityName')"
                          solo flat>
                      </v-autocomplete>
                    </v-flex>

                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Local Line </label>
                      <v-autocomplete
                          :items="city_vise_local_lines"
                          name="Local Line"
                          v-model="updated_local_lines"
                          return-object
                          :item-text="code_with_name"
                          item-value="id"
                          label="Select Local Line"
                          filled
                          chips
                          multiple
                          solo flat :menu-props="{closeOnContentClick:true}"
                          :disabled="announcement_detail.type_object.id==1 || announcement_detail.type_object.id==3">
                      </v-autocomplete>

                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Title </label>
                      <v-text-field
                          name="Title"
                          v-model="announcement_detail.title"
                          label="Title"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('updateAnnouncement.Title')"
                          clearable
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Description: </label>
                      <v-textarea
                          name="Description"
                          v-model="announcement_detail.description"
                          rows="2"
                          label="Description"
                          v-validate="'required'"
                          solo flat
                          :error-messages="errors.collect('updateAnnouncement.Description')"
                          clearable
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md8 lg8 style="display: flex; flex-wrap: wrap;">

                      <v-flex xs12 md6 lg5>
                        <label>Relevant From</label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              v-model="announcement_detail.relevant_from"
                              :config="config"
                              placeholder="Date" v-validate="'required'"
                              :error-messages="errors.collect('updateAnnouncement.Relevant from')"
                              name="Relevant from"/>
                        </div>
                      </v-flex>

                      <v-flex xs12 md6 lg5>
                        <label>Relevant To</label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              label="Relevant To"
                              v-model="announcement_detail.relevant_till"
                              :config="config"
                              placeholder="Date" v-validate="'required'"
                              :error-messages="errors.collect('updateAnnouncement.Relevant to')"
                              name="Relevant to"/>
                        </div>
                      </v-flex>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 sm12 md8 lg8 style="display: flex; flex-wrap: wrap; padding-bottom: 23px !important;">
                      <v-flex xs12 sm6 md6 lg6 style="padding-bottom: 15px !important;">
                        <label>Upload Image</label>
                        <input type="file" name="image_path" id="image_path" class="form-control flatpickerCSS2"
                               v-on:change="imageSelected" v-validate="'ext:jpg,jpeg,png'">
                        <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>
                        <div class="red--text pt-3" v-if="errors.collect('updateAnnouncement.image_path').length">
                          {{ errors.collect('updateAnnouncement.image_path')[0] }}
                        </div>
                      </v-flex>

                      <v-flex xs12 sm12 md6 lg6 row wrap class="ImageDisplay" v-if="announcement_detail.image != null"
                              style="flex-wrap: wrap; flex-direction: column; align-items: center; justify-content: space-around; align-content: space-around;">

                        <v-flex xs10 sm10 md10 lg10 v-if="oldImage"
                                style="height: auto; width: auto;">
                          <img :src="storage_path() + announcement_detail.image"
                               class="figure-img img-fluid rounded"
                               style="max-height:100px; max-width: 100%;">
                        </v-flex>
                        <v-flex xs10 sm10 md10 lg10 v-else>
                          <img :src="announcement_detail.image"
                               class="figure-img img-fluid rounded"
                               style="max-height:100px; max-width: 100%;">
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-btn icon @click="clearImage()">
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-flex>

                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md12 lg8 style="display: flex;">
                      <v-flex xs12 md4 lg4>
                        <v-checkbox
                            v-model="announcement_detail.is_scheduled"
                            label="Is Scheduled"
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12 md8 lg8 v-if="announcement_detail.is_scheduled == 1">
                        <label>Scheduled At: </label>
                        <div style="padding-bottom: 23px !important;">
                          <flat-pickr
                              class="flatpickerCSS2"
                              label="Scheduled At"
                              v-model="announcement_detail.scheduled_at"
                              :config="config"
                              placeholder="Schedule Date & Time" v-validate="'required'"
                              :error-messages="errors.collect('createAnnouncement.Scheduled At')"
                              name="Scheduled At"/>
                        </div>
                      </v-flex>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 lg8>
                      <label>Body: </label>
<!--                      <vue-editor-->
<!--                          name="Announcement Body"-->
<!--                          v-model="announcement_detail.body"-->
<!--                          label="Announcement Body"-->
<!--                          solo flat-->
<!--                      ></vue-editor>-->

                      <quill-editor ref="myQuillEditor"
                                    name="Announcement_Body"
                                    :value="announcement_detail.body"
                                    :options="quillOptions"
                                    label="Announcement Body"
                                    solo flat @input="updateBody" />

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid || announcement_detail.title == '' ||
                (announcement_detail.is_scheduled == 1 && announcement_detail.scheduled_at == '')" type="submit">Update</v-btn>
                <v-btn flat small to="/announcements">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>

      <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-flex>
</template>
<script>
import moment from "moment";
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    // VueEditor,
    flatPickr,
    quillEditor
  },
  watch: {
    "updated_local_lines": function(val){
      let temporary_lines = [];
      val.forEach((element) =>{
        temporary_lines.push(element.name);
      });

      if(!(JSON.stringify(this.old_local_lines) === JSON.stringify(temporary_lines))){
        if (this.announcement_detail.type_object.id == 2) {
          if (val && val.length > 0) {
            const LineArray = [];
            const LineCode = [];

            val.forEach((element) => {
              if(element.id == 0){
                this.local_lines.forEach((element_cr)=>{
                  if(!LineArray.includes(element_cr.name) && !LineCode.includes(element_cr.code)){
                    if(element_cr.id != 0){
                      if(element_cr.division_code == 'cr_mumbai'){
                        LineArray.push(element_cr.name);
                        LineCode.push(element_cr.code);
                      }
                    }
                  }
                });
              }else{
                if(!LineArray.includes(element.name) && !LineCode.includes(element.code)){
                  if(element.id != 0){
                    LineArray.push(element.name);
                    LineCode.push(element.code);
                  }
                }
              }
            });

            let lineName = (LineArray).join(', ');

            const wordIndex = (this.announcement_detail.title).indexOf(" line on ");
            let old_title = "";
            if (wordIndex !== -1) {
              let word = " line on ";
              const textAfterWord = (this.announcement_detail.title).substr(wordIndex + word.length);
              old_title = textAfterWord.trim();
            }

            this.announcement_detail.title = "Megablock on " + lineName + " line on " + old_title;
          }
        }
      }

    },

    "announcement_detail.relevant_from": function (val) {
      if (val != '' || val != null) {
        if (val && (this.announcement_detail.type_object.id == 2 || this.announcement_detail.type_object.id == 4 ||
            this.announcement_detail.type_object.id == 5)) {
          this.announcement_detail.search_announcement.show_from = val;
        }
      }
    },
    "announcement_detail.relevant_to": function (val) {
      if (val != '' || val != null) {
        if (val && (this.announcement_detail.type_object.id == 2 || this.announcement_detail.type_object.id == 4 ||
            this.announcement_detail.type_object.id == 5)) {
          this.announcement_detail.search_announcement.show_till = val;
        }
      }
    },
    "announcement_detail.is_scheduled": function (val){
      if(val == false){
        this.announcement_detail.scheduled_at = "";
      }
    },
    "announcement_detail.body": function (val){
      if(val == '' || val != null){
        setInterval(this.handleTextChange, 1000);
      }
    },
    "announcement_detail.city_id": function (val){
      this.city_vise_local_lines = [];
      if(val != '' || val != null){
        this.local_lines.forEach((item) =>{
          if(item.city_id == val) {
            this.city_vise_local_lines.push(item);
          }
        })
      }else{
        this.local_lines.forEach((item) =>{
          this.city_vise_local_lines.push(item);

        })
      }
    }
  },
  methods: {
    changeType: function (val) {
      this.announcement_detail.relevant_from = null;
      this.announcement_detail.relevant_till = null;
      this.announcement_detail.local_line = null;
      this.announcement_detail.title = null;
      this.announcement_detail.description = null;

      if (val == 1 || val == 3) {
        this.show_search = false;
        this.announcement_detail.search_announcement.show_from = null;
        this.announcement_detail.search_announcement.show_till = null;
      } else {
        this.show_search = true;
        this.announcement_detail.train_announcement.local_train_number = null;
        this.announcement_detail.train_announcement.delay_time = '';
      }


      // if(val == 1 || val == 3){
      //   this.show_search = false
      // }else{
      //   this.show_search = true;
      //      this.is_populate = false;
      // }
      if (val == 1) {
        this.announcement_detail.train_announcement && this.announcement_detail.train_announcement.local_train_number != '' ? this.is_populate = true : this.is_populate = false;
      } else if (val == 3) {
        this.announcement_detail.train_announcement.local_train_number != '' && this.announcement_detail.delay_time != '' ? this.is_populate = true : this.is_populate = false;
      }
    },
    show_date: function (val) {
      if (val == 'from' && this.announcement_detail.type_object.id == 2) {
        this.announcement_detail.relevant_from = this.announcement_detail.search_announcement.show_from;
      } else if (val == 'till' && this.announcement_detail.type_object.id == 2) {
        this.announcement_detail.relevant_till = this.announcement_detail.search_announcement.show_till;
      } else {
        this.announcement_detail.relevant_from = this.announcement_detail.relevant_from;
        this.announcement_detail.relevant_till = this.announcement_detail.relevant_till;
      }

    },
    strippedContent: function (string) {
      return string.replace(/<\/?[^>]+>/ig, " ");
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },


    getAnnouncementDetails: function () {
      this.submit_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/announcement/` +
              this.$route.params.id, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.announcement_detail = response.data.announcement;
              this.announcement_detail.type = Number(this.announcement_detail.type);
              this.announcement_detail.local_line = response.data.line_announcements;
              this.updated_local_lines = response.data.line_announcements;

              response.data.line_announcements.forEach((element) =>{
                this.old_local_lines.push(element.name);
              });

              this.announcement_detail.image = response.data.announcement.image;
              this.oldImage = this.announcement_detail.image;

              this.submit_loader = false;
            }
          })
          .catch(error => {
            console.log(error);
          });
    },

    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/announcement-types`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.announcement_types = response.data.types;
            }

          })
    },

    getLocalLineList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/local-lines`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              // if (this.$store.getters.get_user.roles[0].name == 'cr_cpro_user' ||
              //     this.$store.getters.get_user.roles[0].name == 'cr_controlroom_user' ||
              //     this.$store.getters.get_user.roles[0].name == 'admin') {
                this.local_lines.push({'code': "All CR Mumbai Division", 'name': "all_CR_mumbai_division", 'id': 0});
              // }
              response.data.local_lines.forEach((element) => {
                if(element.id == 2){
                  if(this.$store.getters.get_user.roles[0].name == 'cr_cpro_user' ||
                      this.$store.getters.get_user.roles[0].name == 'cr_controlroom_user'){
                  }else{
                    this.local_lines.push(element);
                  }
                }else{
                  this.local_lines.push(element);
                }
              });

              this.city_vise_local_lines = this.local_lines;

            }
          });
    },

    updateAnnouncement: function () {
      this.submit_loader = true;
      let new_announcement = new Object();
      new_announcement.id = this.announcement_detail.id;
      new_announcement.title = this.announcement_detail.title;
      // new_announcement.pin_till = this.announcement_detail.pin_till;
      new_announcement.description = this.announcement_detail.description;
      new_announcement.type = this.announcement_detail.type_object.id;
      new_announcement.local_line = this.updated_local_lines;
      new_announcement.body = this.announcement_detail.body;
      new_announcement.is_notify = this.announcement_detail.is_notify;
      new_announcement.show_in_search = this.announcement_detail.show_in_train_search;
      // if (this.announcement_detail.show_in_train_search) {
      //   new_announcement.show_from = this.announcement_detail.relevant_from;
      //   new_announcement.show_till = this.announcement_detail.relevant_till;
      // }
      new_announcement.relevant_from = this.announcement_detail.relevant_from;
      new_announcement.relevant_till = this.announcement_detail.relevant_till;

      new_announcement.previewImage = this.announcement_detail.image;

      new_announcement.is_scheduled = this.announcement_detail.is_scheduled;
      new_announcement.scheduled_at = this.announcement_detail.scheduled_at;
      new_announcement.city_id = this.announcement_detail.city_id;

      let local_line_list = [];
      this.updated_local_lines.forEach((element) => {
        if (element.id == 0) {
          this.local_lines.forEach((element_cr) => {
            if (element_cr.division_code == 'cr_mumbai') {
              if (!local_line_list.includes(element_cr.id)) {
                local_line_list.push(element_cr);
              }
            }
          });
        } else {
          if (!local_line_list.includes(element.id)) {
            local_line_list.push(element);
          }
        }
      });

      new_announcement.local_line = Array.from(new Set(local_line_list.map(obj => obj.id))).map(id => {
        return local_line_list.find(obj => obj.id === id);
      });

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-announcement`, new_announcement, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          this.$router.push({name: 'announcements'});
          this.submit_loader = false;
        } else if (response.data.status == 2) {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
          this.$validator.reset();

        } else {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }

      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.submit_loader = false;
      });

    },
    getTrainCodes: function () {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-codes`,
          {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.train_codes = response.data.train_codes;
            }

          })

    },
    create_announcement: function () {
      this.submit_loader = true;
      let new_announcement = Object.assign({}, this.announcement_detail);
      new_announcement.announcement_type_id = this.announcement_detail.train_announcement.announcement_type_id;
      new_announcement.train_code_id = this.announcement_detail.train_announcement.local_train_number;
      new_announcement.delay_time = this.announcement_detail.train_announcement.delay_time;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/announcement-template`, new_announcement, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.announcement_detail.title = response.data.title;
              this.announcement_detail.description = response.data.description;
              this.announcement_detail.local_line = response.data.local_line;
              if (this.announcement_detail.type.id == 1 || this.announcement_detail.type.id == 3) {
                this.announcement_detail.relevant_from = response.data.start;
                this.announcement_detail.relevant_to = response.data.last;
              }
              this.submit_loader = false;
            }

          }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.submit_loader = false;
      });
    },
    getItemText(item) {
      return `${item.number} - ${item.short_code}`;
    },
    imageSelected(e) {
      this.oldImage = '';
      this.image_path = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.image_path);
      reader.onload = e => {
        this.announcement_detail.image = e.target.result;
      };
    },
    clearImage() {
      this.announcement_detail.image = null;
      $('#image_path').val('');

      const index = this.errors.items.findIndex(item => item.field == 'image_path');
      if (index !== -1) {
        this.errors.items.splice(index, 1);
      }
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    handleTextChange() {
      if(this.announcement_detail.body != null || this.announcement_detail.body == ''){
        const containsImages = this.announcement_detail.body.includes('<img');
        if (containsImages) {
          const imageData = this.announcement_detail.body.match(/<img[^>]+src="([^">]+)"/g);


          imageData.forEach((element) => {
            const srcMatch = element.match(/src="([^"]+)"/);

            let Image_data = srcMatch[1];
            if (Image_data.startsWith('data:image/png;base64,') ||
                Image_data.startsWith('data:image/jpg;base64,') ||
                Image_data.startsWith("data:image/jpeg;base64,")) {
              axios.post(`${process.env.VUE_APP_API_URL}/api/v1/add-image-to-azure`, {Image_data})
                  .then(response => {
                    if (response.data.status == 1) {

                      this.image_flag = 1;
                      this.azure_image_path = response.data.data;

                      const new_UrL = process.env.VUE_APP_AZURE_STORAGE_URL +
                      process.env.VUE_APP_AZURE_STORAGE_CONTAINER + '/' + this.azure_image_path;

                      const escapedOldSrc =  this.escapeRegExp(srcMatch[1]);
                      const regex = new RegExp(`<img src="${escapedOldSrc}"`, 'g');
                      this.announcement_detail.body =
                          this.announcement_detail.body.replace(regex, `<img src="${new_UrL}"`);
                    }
                  })
            }
          });
        }
      }
    },
    updateBody(value) {
      this.$set(this.announcement_detail, 'body', value);
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    },
    code_with_name(item){
      return `${item.code} - (${item.name})`;
    }

    // updateBodyTag(value) {
    //   this.announcement_detail.body = this.announcement_detail.body.replace(/<img[^>]+src="([^">]+)"/g,
    //       `<img src="${value}"`);
    // }

  },
  data: () => {
    return {
      is_populate: false,
      current_date: "",
      date: '',
      show_search: true,
      config: {
        enableTime: true,
        altInput: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: false,
        // minDate:"today",
        // minDate:moment().format('YYYY-MM-

      },
      config1: {
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        time_24hr: false,
      },
      status_model: false,
      announcement_status: '',
      updated_local_lines:[],
      old_local_lines:[],
      cityList: [],
      announcement_detail: {
        type_object: {
          id: '',
          color_code: '',
          display_order: '',
          title: ''
        },
        'train_announcement': {},
      },
      submit_loader: false,
      valid: false,
      train_codes: [],
      announcement_types: [],
      local_lines: [],
      auth_user: {
        roles: [{}]
      },
      menu: false,
      modal: false,
      menu2: false,
      workspaceRequestCode: "",
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      oldImage: '',
      quillOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['link'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'direction': 'rtl'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            ['clean'],
            ['image']
          ]
        },
        theme: 'snow'
      },
      azure_image_path: '',
      city_vise_local_lines: [],
    }
  },

  mounted() {
    this.getCityList();
    this.getAnnouncementDetails();
    this.getLocalLineList();
    this.getTypeList();
    // this.getTrainCodes();
  },
};
</script>
<style>
.ql-container.ql-snow  {
  max-height: 300px !important;
  overflow: auto !important;
}
</style>
